import React from 'react';

const Reload = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M23.5293 12.05C23.2393 11.76 22.7593 11.76 22.4693 12.05L22.0093 12.51V12C22.0093 6.47999 17.5193 1.98999 11.9993 1.98999C8.94927 1.98999 6.09927 3.35999 4.18927 5.73999C3.92927 6.05999 3.97927 6.53999 4.30927 6.79999C4.62927 7.04999 5.09927 6.99999 5.35927 6.67999C6.98927 4.64999 9.40927 3.48999 11.9993 3.48999C16.6893 3.48999 20.5093 7.30999 20.5093 12V12.5L20.0493 12.04C19.7593 11.75 19.2793 11.75 18.9893 12.04C18.6993 12.33 18.6993 12.81 18.9893 13.1L20.7293 14.84C20.7993 14.91 20.8793 14.96 20.9693 15C21.0593 15.04 21.1593 15.06 21.2593 15.06C21.3593 15.06 21.4493 15.04 21.5493 15C21.6393 14.96 21.7193 14.91 21.7893 14.84L23.5293 13.1C23.8193 12.82 23.8193 12.34 23.5293 12.05Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.6875 17.2C19.3675 16.94 18.8875 16.99 18.6375 17.32C17.0075 19.35 14.5875 20.51 11.9975 20.51C7.3075 20.51 3.4875 16.69 3.4875 12V11.5L3.9475 11.96C4.0975 12.11 4.2875 12.18 4.4775 12.18C4.6675 12.18 4.8575 12.1 4.9975 11.95C5.2875 11.66 5.2875 11.18 4.9975 10.89L3.2675 9.14999C3.1975 9.08999 3.1075 9.02999 3.0175 8.98999C2.8375 8.90999 2.6275 8.90999 2.4475 8.98999C2.3575 9.02999 2.2775 9.08999 2.2075 9.14999L0.4675 10.89C0.1775 11.18 0.1775 11.66 0.4675 11.95C0.7575 12.24 1.2375 12.24 1.5275 11.95L1.9875 11.49V12C1.9875 17.52 6.4775 22.01 11.9975 22.01C15.0475 22.01 17.8975 20.64 19.8075 18.26C20.0675 17.94 20.0175 17.46 19.6875 17.2Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.4058 14.3933C15.4058 15.8908 14.3544 16.8684 12.7921 17.1641C12.54 17.2118 12.3448 17.4239 12.3448 17.6804V17.9642C12.3448 18.2426 12.1174 18.4674 11.839 18.4642L11.6118 18.4616C11.3379 18.4584 11.1175 18.2355 11.1175 17.9616V17.6538C11.1175 17.4026 10.9297 17.1937 10.6849 17.1369C9.25888 16.8064 8.31093 15.8066 8.05984 14.3954C8.00962 14.1132 8.24094 13.8713 8.52765 13.8713H8.96721C9.2262 13.8713 9.43664 14.0711 9.49965 14.3223C9.75276 15.3313 10.5431 15.9591 11.7664 15.9591C13.0077 15.9591 13.9106 15.4795 13.9106 14.4074C13.9106 12.0375 8.31034 13.4623 8.31034 9.82282C8.31034 8.52729 9.24343 7.55835 10.6748 7.25538C10.9244 7.20254 11.1175 6.99171 11.1175 6.73658V6.5C11.1175 6.22386 11.3414 6 11.6175 6H11.8448C12.1209 6 12.3448 6.22386 12.3448 6.5V6.76276C12.3448 7.01272 12.5306 7.22072 12.7733 7.28045C14.0055 7.58367 14.8648 8.42634 15.1308 9.60242C15.1948 9.88532 14.9617 10.1332 14.6717 10.1332H14.2373C13.9799 10.1332 13.7725 9.93391 13.6898 9.69016C13.4315 8.92903 12.7081 8.4545 11.6818 8.4545C10.4968 8.4545 9.7774 8.99054 9.7774 9.82282C9.7774 12.2209 15.4058 10.6269 15.4058 14.3933Z",
      fill: "white"
    }
  )
);
Reload.displayName = "Icons.Reload";

export { Reload };
//# sourceMappingURL=Reload.js.map
